// src/sot/primitives/AfriPill.jsx
import React from "react";

export default function AfriPill({
  value,
  label,
  isActive,
  onChange,
  size = "medium", // "medium" for Home, "small" for Notifications
  variant = "home", // "home" | "notifications" | "doctor" | "appointments"
  iconLeft, // ✅ optional: "/icons/..."
}) {
  const sizeClass = size === "small" ? "afri-pill--sm" : "afri-pill--md";

  let stateClass = "afri-pill--idle";

  if (isActive) {
    if (variant === "notifications") stateClass = "afri-pill--notifications-active";
    else if (variant === "doctor") stateClass = "afri-pill--doctor-active";
    else if (variant === "appointments") stateClass = "afri-pill--doctor-active";
    else stateClass = "afri-pill--home-active";
  }

  return (
    <button
      type="button"
      onMouseDown={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onChange?.(value);
      }}
      className={`afri-pill ${sizeClass} ${stateClass}`}
    >
      {iconLeft ? (
        <span className="afri-pill__icon" aria-hidden="true">
          <img src={iconLeft} alt="" draggable="false" />
        </span>
      ) : null}
      {label}
    </button>
  );
}